export default function TrustBadges() {
    return (
        <div className="mt-4 flex items-center justify-between gap-4">
            <img
                src={`${import.meta.env.VITE_CDN_URL}/images/trustpilot_rating.webp`}
                alt="trustpilot rating"
                className="h-auto w-[55%]"
            />
            <img
                src={`${import.meta.env.VITE_CDN_URL}/images/easy_cancel.webp`}
                alt="easy cancel fair membership"
                className="h-auto w-[30%]"
            />
        </div>
    );
}
